import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import numeral from 'numeral';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
import withData from '@bd/bdcore-data';
import { colors } from '../styles';

const styles = css`
.HomeMapCard_wrapper {
  padding: 10px;
  min-width: 200px;
}
.HomeMapCard_content {
  h4 {
    font-size: 16px;
    border-bottom: 1px solid ${colors.color2};
    padding-bottom: 5px;
  }
}
.HomeMapCard_detailButton {
  display: block;
  background-image: url('/images/icon-arrow-gold.svg');
  background-position: right;
  background-repeat: no-repeat;

  span {
    color: #000000;
    font-size: 14px;
  }
}
`;

function HomeMapCard({ home }) {
  return (
    <div className={styles}>
      <div className="HomeMapCard_wrapper">
        <div className="HomeMapCard_inner">
          <div className="HomeMapCard_content">
            <h4>{get(home, 'address.streetAddress')}</h4>
            <div className="HomeMapCard_buttonWrapper">
              <Link name="home-detail" home={home} className="HomeMapCard_detailButton">
                <span>{get(home, 'address.addressLocality')}, {get(home, 'address.addressRegion')}</span><br />
                <span>Price: {numeral(get(home, 'price')).format('$0,0')}</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

HomeMapCard.propTypes = {
  home: PropTypes.object.isRequired,
};

HomeMapCard.defaultProps = {
  community: undefined,
};

export default withData(
  {
    home: true,
    community: true,
  },
  {
    required: {
      home: true,
    },
  },
)(HomeMapCard);



// WEBPACK FOOTER //
// ./src/components/HomeMapCard.js